// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#344E41","makerBrown":"#524E3D","makerGreen":"#3A5A40","makerLightGrey":"#DAD7CD","makerLightGreen":"#A3B18A","makerWhite":"#fafafa","btn":"btn_btn__2Lemh"};